<csv-preview-modal>

    <dialog class="modal" ref="dialog" aria-labelledby="csv-preview-modal-heading">
        <div class="modal-box w-[90vw] max-w-[90vw] max-h-[90vh] flex flex-col text-primary">
            <div class="flex items-center gap-3 mb-3">
                <h3 id="csv-preview-modal-heading" class="font-bold text-lg flex-1">{locale?.t('csvpreview_title')}</h3>
                <span if="{state.rows.length}" class="text-sm font-semibold text-gray-500 me-2">{locale?.t('csvpreview_rows', { count: state.rows.length })}</span>
                <form method="dialog">
                    <button class="cursor-pointer text-xl leading-none"
                            aria-label="{locale?.t('close')}"
                            onclick="{handleClose}">
                        <i class="icon-clear"></i>
                    </button>
                </form>
            </div>

            <div if="{!state.headers.length}" class="py-16 text-center text-sm text-gray-600">
                {locale?.t('csvpreview_empty')}
            </div>

            <div if="{state.headers.length}" class="csv-preview-scrollbox flex-1 min-h-0 overflow-auto border border-base-300 rounded-lg">
                <table class="table table-sm table-zebra text-base-content w-full">
                    <thead class="sticky top-0 z-10">
                        <tr>
                            <th each="{(header, i) in state.headers}" key="{i}" scope="col" class="min-w-[160px] px-2 py-1 whitespace-nowrap bg-emerald-700 text-white font-semibold">{header}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr each="{(row, r) in pagedRows()}" key="{r}">
                            <td each="{(cell, c) in row}" key="{c}" class="min-w-[160px] align-top px-2 py-1 whitespace-pre-wrap [overflow-wrap:anywhere]">{cell}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="modal-action items-center gap-4">
                <pagination if="{state.headers.length}"
                            class="[&>div]:!pt-0"
                            pagelengths="{[5, 10, 20, 50, 100]}"
                            pagelength="{state.pageLength}"
                            pageindex="{state.pageIndex}"
                            totalpages="{totalPages()}"
                            onPageLengthChange="{onPageLengthChange}"
                            onPageIndexChange="{onPageIndexChange}">
                </pagination>
                <form method="dialog" class="flex gap-2 ms-auto">
                    <button class="btn text-primary rounded-lg"
                            aria-label="{locale?.t('cancel')}"
                            onclick="{handleClose}">{locale?.t('cancel')}</button>
                </form>
                <button class="btn btn-primary rounded-lg flex flex-row items-center gap-2"
                        aria-label="{locale?.t('csvpreview_download')}"
                        disabled="{!state.csvText}"
                        onclick="{handleDownload}">
                    <i class="icon-metalark-download"></i>
                    {locale?.t('csvpreview_download')}
                </button>
            </div>
        </div>

        <form method="dialog" class="modal-backdrop">
            <button aria-label="{locale?.t('close')}"
                    onclick="{handleClose}">{locale?.t('close')}</button>
        </form>
    </dialog>

    <script>
        import pagination from './pagination.tag';

        export default {
            get components() {
                return { pagination };
            },

            defaultState() {
                return {
                    csvText: '',
                    filename: '',
                    headers: [],
                    rows: [],
                    pageIndex: 1,
                    pageLength: 10
                };
            },

            state: {
                csvText: '',
                filename: '',
                headers: [],
                rows: [],
                pageIndex: 1,
                pageLength: 10
            },

            modalEl() {
                return this.$('dialog');
            },

            show(csvText, filename) {
                const parsed = this.parseCsv(csvText || '');
                this.update({
                    ...this.defaultState(),
                    csvText: csvText || '',
                    filename: filename || 'export.csv',
                    headers: parsed.length ? parsed[0] : [],
                    rows: parsed.slice(1)
                });
                this.modalEl().showModal();

                const scrollbox = this.$('.csv-preview-scrollbox');
                if (scrollbox) {
                    scrollbox.scrollTop = 0;
                    scrollbox.scrollLeft = 0;
                }
            },

            close() {
                this.modalEl().close();
            },

            clearState() {
                this.update(this.defaultState());
            },

            handleClose() {
                this.close();
            },

            parseCsv(text) {
                const rows = [];
                let row = [];
                let field = '';
                let inQuotes = false;
                const s = String(text).replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                for (let i = 0; i < s.length; i++) {
                    const c = s[i];
                    if (inQuotes) {
                        if (c === '"') {
                            if (s[i + 1] === '"') { field += '"'; i++; }
                            else { inQuotes = false; }
                        } else {
                            field += c;
                        }
                    } else if (c === '"') {
                        inQuotes = true;
                    } else if (c === ',') {
                        row.push(field);
                        field = '';
                    } else if (c === '\n') {
                        row.push(field);
                        rows.push(row);
                        row = [];
                        field = '';
                    } else {
                        field += c;
                    }
                }
                if (field !== '' || row.length) {
                    row.push(field);
                    rows.push(row);
                }
                if (rows.length && rows[rows.length - 1].length === 1 && rows[rows.length - 1][0] === '') {
                    rows.pop();
                }
                return rows;
            },

            totalPages() {
                return Math.max(1, Math.ceil(this.state.rows.length / this.state.pageLength));
            },

            pagedRows() {
                const start = (this.state.pageIndex - 1) * this.state.pageLength;
                return this.state.rows.slice(start, start + this.state.pageLength);
            },

            onPageLengthChange(e) {
                this.update({ pageLength: parseInt(e.target.value), pageIndex: 1 });
            },

            onPageIndexChange(newIndex) {
                this.update({ pageIndex: newIndex });
            },

            handleDownload() {
                if (!this.state.csvText) return;
                const blob = new Blob([this.state.csvText], { type: 'text/csv' });
                this.tools.downloadBlob(blob, this.state.filename);
            },

            onMounted() {
                window.csvPreviewModal = this;
                this.modalEl().addEventListener('close', () => this.clearState());
            }
        }
    </script>
</csv-preview-modal>
